import "../../../grjs7/dist/gr_reco7";
import { init } from "../../init";
import sideBar from "./html/sidebar.html";
import belowArticle from "./html/belowTheArticle.html";

const PUBLISHER_ID = "1243549";
const PLACEMENT_SELECTORS = ["#tbla-content-recirc-placement", "#tbla-content-recirc-sidebar"];

// can be beforeend, afterend, beforebegin, afterbegin
// https://developer.mozilla.org/en-US/docs/Web/API/Element/insertAdjacentHTML
const PLACEMENT_TARGET = "beforeend";

const PLACEMENT_UNIQUE_ID = "GR_PLACEMENT_12221132";

const NUMBER_LIMIT_FOR_RECOMMENDABLE_ITEMS = 9;
const SCENARIO_ID = "ECREC";
const PROPERTY_LIST = ["url", "itemid", "imageUrl", "ogtitle", "description", "headkicker", "category", "headkickerUrlEncoded"];
const TEMPLATE = belowArticle;
const GROUP_ID = "GROUP_2";

const SCENARIO_ID_2 = "ECREC_SIDEBAR";
const ELEMENT_TO_HIDE_2 = ".css-1p4rqi2-StyledGridItem";
const TEMPLATE_2 = sideBar;
const PLACEMENT_UNIQUE_ID_2 = "GR_PLACEMENT_12221132_SIDEBAR";

function isRecommendationEnabled() {
  const { pathname, hostname } = window.location;
  if (hostname === "perthnow.com.au") {
    return pathname.startsWith("/shop-now");
  }
  return hostname === "perthnow.dev.swmdigital.io" || hostname === "skillful-respected-globe.glitch.me";
}

function customScriptAfter(items) {
  try {
    items.forEach((item) => {
      const headkicker = item.querySelector("[data-tbl-encoded-headkicker]");
      if (headkicker) {
        headkicker.innerHTML = decodeURI(headkicker.dataset.tblEncodedHeadkicker);
      }
    });
  } catch (e) {
    console.error(e);
  }
}

/**
    @param {string} containerSelector - The selector of the container where the recommendation box will be placed
    @param {string} targetPosition - The position where the recommendation box will be placed
    @param {string} placementId - The id of the placement that should be unique
    @param {string} scenarioId - The id of the scenario for recommendation LOGIC
    @param {string[]} resultNames - Parameter list for RECO to give values for
    @param {number} numberLimit - How many items should be recommended by reco
    @param {string} template - The template of the recommendation box
    @param {number} groupSize - The size of the group  TODO: can be calculated from the length of the PLACEMENT_DATA
    @param {number} groupSeq - The sequence of the group  TODO can be calculated from the index of the PLACEMENT_DATA
    @param {string} groupId - The id of the group that it's useful for grouping the PLACEMENT_DATA items
    @param {string} elementToHide - The element that should be hidden if the recommendation box is NOT empty
*/

const PLACEMENT_1 = [
  PLACEMENT_SELECTORS[0],
  PLACEMENT_TARGET,
  PLACEMENT_UNIQUE_ID,
  SCENARIO_ID,
  PROPERTY_LIST,
  NUMBER_LIMIT_FOR_RECOMMENDABLE_ITEMS,
  TEMPLATE,
  2,
  1,
  GROUP_ID,
];

const PLACEMENT_2 = [
  PLACEMENT_SELECTORS[1],
  PLACEMENT_TARGET,
  PLACEMENT_UNIQUE_ID_2,
  SCENARIO_ID_2,
  PROPERTY_LIST,
  NUMBER_LIMIT_FOR_RECOMMENDABLE_ITEMS,
  TEMPLATE_2,
  2,
  2,
  GROUP_ID,
  ELEMENT_TO_HIDE_2,
];

const PLACEMENT_DATA = [PLACEMENT_1, PLACEMENT_2];

function initCallback() {
  /**   
        @param {function Boolean} isRecommendationEnabled - Function that returns a boolean value whether the recommendation should be enabled or not
        @param {string} PUBLISHER_ID - Prefix for itemIds and value for Advertiser ID
        @param {Array} PLACEMENT_DATA - Recommendation details
        @param {string} initCallback - Function for intialization in case of navigation with SPA
        @param {string} CSS_OVERRIDE - CSS for adjustemnts on Publisher page elements   
        @param {boolean} isInsertCSSReset - whether to insert CSS reset for recommendation box, default is true
        @param {customCarousel} function - unique full functionality for carousel 
        @param {customScriptAfter} function - customScript at the after recommendation
        @param {customScriptBefore} function - customScript at the beginning of the init function 
        @param {disabledRecommendationAfterScript} function - customScript for disabled recommendation
    */
  init(isRecommendationEnabled, PUBLISHER_ID, PLACEMENT_DATA, initCallback, undefined, false, undefined, customScriptAfter);
}

initCallback();

